export default "__VITE_ASSET__BKUsmNXv__"